export default __webpack_public_path__ + "static/2-fb571d9bd2e0ce502de23f884801a9d4.jpeg";